import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AzureFileManagerService } from 'app/infrastructure/services/azureFileManager.service';
import { File64 } from 'app/helpers/components/sxFileImport/file64.interf';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { SxHttpService } from 'app/infrastructure/services/sxHttp.service';
import { AzureFile } from 'app/infrastructure/model/interfaces/azureFile.Interface';

@Component({
    templateUrl: 'import.productreport.component.html'
})
export class ImportProductReportComponent implements OnInit {
    public search: string;

    systemCode: string;
    businessCode: string;
    productCode: string;
    productReportCode: string;
    preguntarSiDeseaBorrar = [];
    azureFiles: AzureFile[] = [];
    supported: string[] = ['.docx', '.pdf'];

    file: File64 = null;
    
    constructor(private aRoute: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private sxHttp: SxHttpService,
        //private location: Location,
        private fileManagerService: AzureFileManagerService) { }

    ngOnInit() {
        this.aRoute.params.subscribe(params => {
            this.systemCode = params['codsistema'];
            this.businessCode = params['codnegocio'];
            this.productCode = params['codproducto'];
            this.productReportCode = params['productReportCode'];
            this.getFiles();
        });
    }

    uploadFile() {
        if (!this.file) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0002_MUST_SELECT_A_FILE'
            });
            return;
        }

        if (!this.isPropperFile(this.file.fileName)) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0006_FILE_MUST_BE_XLSX'
            });

            return;
        }

        let fileToUpload: any;

        fileToUpload = {
            systemCode: this.systemCode,
            BusinessCode: this.businessCode,
            ProductCode: this.productCode,
            fileName: this.file.fileName,
            folder: this.productReportCode,
            file: this.file.fileData
        };

        this.fileManagerService.uploadProductReportFile(fileToUpload).then(response => {
            this.file = null;
            this.getFiles();
        });
    }

    getFiles() {
        this.azureFiles = [];
        this.fileManagerService.getProductReportFiles(this.systemCode, this.businessCode, this.productCode, this.productReportCode).subscribe(files => {
            this.azureFiles = files;
        });
    }

    selectedFile(imp: File64) {
        this.file = imp;
    }

    isPropperFile(fileName: string): boolean {
        const ext = fileName.split('.').pop().replace(/^/, '.');
        if (ext !== '.docx' && ext !== '.pdf') {
            return false;
        }
        return true;
    }

    /* goBack() {
         this.location.back();
     }*/
    isNotAvailable(value: boolean) {
        if (value)
            this.file = null;
    }
    disableSave() {
        let disable = false;

        if (this.azureFiles.length === 0) {
            disable = this.file === null;
        } else {
            disable = true;
        }
        
        return disable;
    }

    disableScan() {
        return this.azureFiles.length === 0;
    }

    gotToScan() {
        this.router.navigate(['../mapping'], { relativeTo: this.aRoute });
    }

    deletFile(file: AzureFile) {
        this.fileManagerService.deleteProductReportFile(this.systemCode, this.businessCode, this.productCode, this.productReportCode, file).subscribe(
            result => {
                let type = GrowlType.SUCCESS;
                let body = 'FILE_DELETED';

                if (!result) {
                    type = GrowlType.DANGER;
                    body = 'SOC_FE_0007_FILE_COULD_NOT_BE_DELETED';
                } else {
                    this.getFiles();
                }

                return this.alertService.showGrowl({
                    type: type,
                    body: body,
                });
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/productReport/import/import.productreport.component.ts